// extracted by mini-css-extract-plugin
module.exports = {"btn":"EnableComputer_btn__hU2NT"};